import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { useCsAttribute } from "@plansoft-configuration-renderer/framework";
import { useUiTranslator } from "@plansoft-configuration-renderer/localization";
export function EditNotSupported() {
    const t = useUiTranslator();
    const attribute = useCsAttribute();
    const message = t("ConfigurationRenderer:Warnings.dataTypeNotSupported.editable", "Editable controls for this data type are not supported");
    return (_jsxs(Alert, { severity: "warning", children: [_jsx(AlertTitle, { children: attribute.id }), message, " ", _jsx("code", { children: attribute.dataType })] }));
}
//# sourceMappingURL=Edit.NotSupported.js.map